import React, { useState, useEffect } from "react";
import { getStudentIdData } from "../../../../lib/studentsupplemantalessay";
import style from "./suplementalessayforprofile.module.css"

export default function SuplementalEssayForProfile({ slug }) {
  const [essayList, setEssayList] = useState([]);

  async function getDatafromSuplementalEssay() {
    const essays = await getStudentIdData(slug);
    console.log("Essay List: ", essays);
    const sortedEssaylist = [...essays].sort((a, b) => a.id - b.id);
    setEssayList(sortedEssaylist);
  }

  useEffect(() => {
    getDatafromSuplementalEssay();
  }, [setEssayList]);

  return (
    <div className="card-body">
      <div className="row">
        <div className="col-md-12">
          <h4 className="goal_settings_title">Supplemental Essay</h4>
          <div className="wishlist-item mt-5">
            <div>
              {essayList.map((data) => (
                <div
                  key={data.id}
                  style={{ color: "black", 
                    backgroundColor: "white",
                    borderBottom: "3px solid grey",
        paddingBottom: "10px", 
        marginBottom: "20px"
                   }}
                >
                  <div className="mb-3 fw-bold"> 
                  Supplemental Essay - {data.id}
                  </div>
                  <div className="mb-3">
                    <label className={`${style.essayTitle} form-label fw-bold`}>College:</label>
                    <div>{data.college}</div>
                  </div>

                  <div className="mb-3">
                    <label className={`${style.essayTitle} form-label fw-bold`}>Prompt:</label>
                    <div>{data.prompt}</div>
                  </div>

                  <div className="mb-3">
                    <label className={`${style.essayTitle} form-label fw-bold`}>
                      Instructor Note:
                    </label>
                    <div>{data.InstructorNote}</div>
                  </div>

                  <div className="mb-3">
                    <label className={`${style.essayTitle} form-label fw-bold`}>Student Note:</label>
                    <div>{data.studentNote}</div>
                  </div>

                  <div className="mb-3">
                    <label className={`${style.essayTitle} form-label fw-bold`}>Essay:</label>
                    <div
                    className={`${style.essayItem}`}
                      style={{ lineHeight: "1.6", marginTop: "10px" }}
                      dangerouslySetInnerHTML={{ __html: data.essay }}
                    />
                  </div>

                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}